const { createContext } = require('react');

export const OverlayContext = createContext({});
